<template>
  <div class="mr-3">
    <button
      type="button"
      :class="[
        'btn btnclass smallerfontsize',
        value.length > 0 ? 'selected' : ''
      ]"
      @click="fieldData.showWeekdayModal = true"
    >
      Day of week TV
    </button>
    <b-modal
      :no-close-on-backdrop="true"
      @shown="popupIsShown"
      @hide="popupIsHidden"
      @ok="saveWeekday"
      v-model="fieldData.showWeekdayModal"
      size="sm"
      body-class="weekdaysmodal"
      title="Day of week TV"
    >
      <b-form-group>
        <b-form-checkbox
          v-model="allIsSelected"
          @change="selectAll"
          class="columncheckbox centerlabelandformgroup"
        >
          {{ allIsSelected ? "Deselect all" : "Choose all" }}
        </b-form-checkbox>
        <b-form-checkbox-group
          v-model="chosenWeekdays"
          :options="fieldData.config.options"
          stacked
          class="weekdaysdd centerlabelandformgroup"
        ></b-form-checkbox-group>
      </b-form-group>
      <template #modal-footer="{ cancel, ok }">
        <b-button size="sm" variant="outline-secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button size="sm" variant="primary" @click="ok()">
          Save
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import computedVal from "@/mixins/computedVal";
import props from "@/mixins/inputProps";
export default {
  name: "WeekdaysBubble",
  mixins: [computedVal, props],
  data() {
    return {
      selected: [], // Must be an array reference!
      allIsSelected: false,
      chosenWeekdays: [],
      isOpen: false
    };
  },
  computed: {
    label: function() {
      let NumberOf = this.getSelectedWeekDayCount();
      if (NumberOf == 0) return this.fieldData.label;
      return this.fieldData.label + " (" + NumberOf + " selected)";
    }
  },
  methods: {
    onKeyUp(event) {
      if (event.key === "Enter" && this.fieldData.showWeekdayModal) {
        this.saveWeekday();
        this.fieldData.showWeekdayModal = false;
      }
    },
    popupIsShown() {
      this.chosenWeekdays = [...this.$store.getters[this.getter].weekdays];
      document.addEventListener("keyup", this.onKeyUp);
      if (this.chosenWeekdays.length === 7) this.allIsSelected = true;
      else if (this.chosenWeekdays.length === 0) this.allIsSelected = false;
    },
    popupIsHidden(e) {
      document.removeEventListener("keyup", this.onKeyUp);
      if (e.trigger === "ok" || e.trigger == "event" || e.trigger === null)
        return;
      let query = this.$store.getters[this.getter];
      let isWeekdayChanged = this.isWeekdayChanged(
        query.weekdays,
        this.chosenWeekdays
      );
      if (isWeekdayChanged) {
        let query = this.$store.getters[this.getter];
        this.chosenWeekdays = query.weekdays ? [...query.weekdays] : [];
      }
    },
    isWeekdayChanged(array1, array2) {
      // Check if the lengths are different
      array1.sort();
      array2.sort();
      if (array1.length !== array2.length) {
        return true;
      }

      // Check each element of the arrays
      for (let i = 0; i < array1.length; i++) {
        if (array1[i] !== array2[i]) {
          return true;
        }
      }

      // If no differences are found, return false
      return false;
    },
    getSelectedWeekDayCount() {
      return this.chosenWeekdays.length;
    },
    selectAll(checked) {
      if (checked) {
        this.chosenWeekdays = this.fieldData.config.options.map(
          opt => opt.value
        );
      } else {
        let options = this.fieldData.config.options.filter(opt => {
          if (opt.disabled) return opt;
        });
        this.chosenWeekdays = options;
      }
    },
    saveWeekday() {
      const updatedQuery = {
        ...this.$store.getters[this.getter],
        weekdays: this.chosenWeekdays
      };
      this.$store.commit(this.setter, updatedQuery);
    }
  }
};
</script>
<style scoped>
.crossbtn {
vertical-align: bottom;
}
>>> .columncheckbox, >>> .weekdaysdd .custom-control.custom-checkbox {
  display: flex;
}
.centerlabelandformgroup {
  width: 8rem;
  margin-left: 1rem;
}
</style>
